// src/components/resources/calculators/VideoDropoffCalculator.related.ts

/**
 * Hand-curated cross-links for the Video Drop-off calculator's
 * "Related concepts & calculators" section. Same lift-for-testability
 * rationale as `ROASCalculator.related.ts`.
 */

import type { RelatedLinkEntry } from './ROASCalculator.related'

export const VIDEO_DROPOFF_RELATED_GLOSSARY: ReadonlyArray<RelatedLinkEntry> = [
  { slug: 'metrics/thruplay-rate', label: 'ThruPlay Rate', note: 'Meta-defined 15s / 97% completion bar — the platform-native counterpart.' },
  { slug: 'metrics/video-completion-rate-vcr', label: 'Video Completion Rate (VCR)', note: 'Full-view percentage; pairs with drop-off to size the leak.' },
  { slug: 'metrics/cost-per-thruplay', label: 'Cost per ThruPlay', note: 'Cost efficiency of completed views — drop-off pushes this up.' },
  { slug: 'metrics/thumbstop-rate-tsr', label: 'Thumbstop Rate', note: 'The first-frame retention drop the chart\'s 0-3s bucket captures.' },
  { slug: 'metrics/hold-rate', label: 'Hold Rate', note: 'Retention after the hook — isolates body pacing from thumbstop strength.' },
  // `creative/creative-fatigue` matches the on-disk MDX path
  // (`public/resources/glossary/creative/creative-fatigue.md`).
  { slug: 'creative/creative-fatigue', label: 'Creative Fatigue', note: 'Why retention curves shift downward over a campaign\'s flight.' },
] as const

export const VIDEO_DROPOFF_RELATED_TOOLS: ReadonlyArray<RelatedLinkEntry> = [
  { slug: 'roas-calculator', label: 'ROAS Calculator', note: 'Tie the retention leak to the revenue impact downstream.' },
  { slug: 'creative-testing-calculator', label: 'Creative Testing Calculator', note: 'Sample sizes for A/B-testing the retention fix you build.' },
  { slug: 'cpm-calculator', label: 'CPM Calculator', note: 'How auction cost compounds with poor retention.' },
] as const
